<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden sm:rounded-lg">
            <div class="relative divide-y divide-gray-200">
              <table class="min-w-full" :class="[hasMedia && 'divide-y divide-gray-200']">
                <tbody class="relative">
                  <template v-for="mediaId in accProductTemplate.media">
                    <MediaListItem
                      :key="mediaId.id"
                      :acc-product-template-id="accProductTemplateId"
                      :media-id="mediaId"
                      :is-cover="mediaId === accProductTemplate.coverMediaId"
                    />
                  </template>
                </tbody>
                <tbody class="relative">
                  <tr>
                    <td colspan="2" class="p-4 bg-white">
                      <AddMediaAction :acc-product-template-id="accProductTemplateId" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaListItem from './MediaListItem.vue';
import AddMediaAction from './AddMediaAction.vue';

export default {
  components: {
    MediaListItem,
    AddMediaAction,
  },
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accProductTemplate() {
      return this.$store.state.entities.accProductTemplates.byId[this.accProductTemplateId];
    },
    hasMedia() {
      const { media } = this.accProductTemplate || {};
      return Array.isArray(media) && media.length > 0;
    },
  },
};
</script>
